import script from "./ModalFaleConosco.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFaleConosco.vue?vue&type=script&setup=true&lang=js"

import "./ModalFaleConosco.vue?vue&type=style&index=0&id=bfc1a668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfc1a668"]])

export default __exports__